import type { FaireProductEntity } from "../../entity_types/product";

export const p_e7atjqef73: FaireProductEntity = {
  token: "p_e7atjqef73",
  type: "product",
  name: "Jennifer Petite Pearl Anklet",
  brandName: "[KI\u2022ELE]",
  imageUrl:
    "https://cdn.faire.com/fastly/812ae8c6161cbbe00ac0f93efc7472d3373a406e71a53a47aea5c6207d1202ce.jpeg",
  priceDollars: 27,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/fc926a5f847d123db4f8fcf6ba04e346a562be01641948eff43b56e3af047b77.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
